import type { ApiClient } from "@/modules/api/apiClient.ts";
import { getResponseData } from "@/modules/api/apiClient.ts";
import { atomFromStandardQueryOptions } from "@/utils/query/queryAtom.ts";
import { queryOptions, type QueryKey } from "@tanstack/react-query";
import type { MetalOsListResponse } from "@warrenio/api-spec/spec.oats.gen";

type Response = MetalOsListResponse;

export const queryKey: QueryKey = ["metal_os"];

function getQuery(client: ApiClient) {
    return queryOptions({
        queryKey,
        queryFn: async ({ signal }): Promise<Response> => {
            return getResponseData(await client.GET("/metal/os", { signal }));
        },
    });
}

export const metalOsQueryAtom = atomFromStandardQueryOptions(getQuery);
